import { createContext } from 'react';

import { PreparedWorkload } from 'features/workload-optimization';

export const OptimizationWorkloadsListContext = createContext<{
  workloads: PreparedWorkload[];
  isLoading: boolean;
  hasError: boolean;
  refetch: () => void;
  isNamespaceWritable: (namespace: string | undefined) => boolean;
}>({
  isLoading: true,
  workloads: [],
  hasError: false,
  refetch: () => {},
  isNamespaceWritable: () => true,
});
